import {
  alpha,
  Box,
  Card,
  CardContent,
  Icon,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

export default function KpiCard({ title, value, icon, color, subtitle }) {
  const theme = useTheme();
  return (
    <Card
      elevation={0}
      sx={{
        border: `1px solid ${alpha(color, 0.25)}`,
        borderRadius: 3,
        height: "100%",
        background: `linear-gradient(135deg, ${alpha(color, 0.07)} 0%, ${
          theme.palette.background.paper
        } 100%)`,
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: `0 8px 24px ${alpha(color, 0.2)}`,
        },
      }}
    >
      <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Box flex={1} minWidth={0}>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={700}
              textTransform="uppercase"
              letterSpacing={0.7}
              display="block"
            >
              {title}
            </Typography>
            <Typography
              variant="h4"
              fontWeight={800}
              color={color}
              mt={0.3}
              lineHeight={1.1}
            >
              {value}
            </Typography>
            {subtitle && (
              <Typography
                variant="caption"
                color="text.secondary"
                mt={0.3}
                display="block"
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 2.5,
              flexShrink: 0,
              ml: 1,
              bgcolor: alpha(color, 0.13),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon sx={{ color, fontSize: 22 }}>{icon}</Icon>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
